"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCustomEvent = createCustomEvent;
/**
* Creates a custom event with the specified name and data.
* @param name The name of the event.
* @param data The data to include in the event.
* @returns A new CustomEvent instance.
*/
function createCustomEvent(name, data) {
  return new CustomEvent(name, {
    detail: data
  });
}
//# sourceMappingURL=createCustomEvent.js.map